import React, { useEffect } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { Spin } from 'antd'
import useAuthStore from './store/authStore'

// Layout
import DashboardLayout from './components/Layout/DashboardLayout'
import ProtectedRoute from './components/Auth/ProtectedRoute'

// Pages
import Login from './pages/Login'
import ForgotPassword from './pages/ForgotPassword'
import ResetPassword from './pages/ResetPassword'
import Dashboard from './pages/Dashboard'
import AIModels from './pages/AIModels'
import APISubscriptions from './pages/APISubscriptions'
import SubscriptionPlans from './pages/SubscriptionPlans'
import System from './pages/System'
import Admins from './pages/Admins'
import AuditLog from './pages/AuditLog'
import Profile from './pages/Profile'
import Pipelines from './pages/Pipelines'
import Portfolios from './pages/PortfoliosEnhanced'
import CronJobs from './pages/CronJobs'
import DuckDBExplorer from './pages/DuckDBExplorer'
import PostgresExplorer from './pages/PostgresExplorer'
import Blog from './pages/Blog'
import ModelValidation from './pages/ModelValidation'
import SEORankings from './pages/SEORankings'
import AIVisibility from './pages/AIVisibility'
import HealthCheck from './pages/HealthCheck'

function App() {
  const { verifyToken, isAuthenticated } = useAuthStore()
  const [loading, setLoading] = React.useState(true)

  useEffect(() => {
    const checkAuth = async () => {
      await verifyToken()
      setLoading(false)
    }
    checkAuth()
  }, [verifyToken])

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <Spin size="large" spinning={true}>
          <div className="p-12">Loading ACIS Admin Portal...</div>
        </Spin>
      </div>
    )
  }

  return (
    <Routes>
      {/* Public routes */}
      <Route path="/login" element={isAuthenticated ? <Navigate to="/" /> : <Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />

      {/* Protected routes */}
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <DashboardLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="portfolios" element={<Portfolios />} />
        <Route path="ai-models" element={<AIModels />} />
        <Route path="model-validation" element={<ModelValidation />} />
        <Route path="seo-rankings" element={<SEORankings />} />
        <Route path="ai-visibility" element={<AIVisibility />} />
        <Route path="pipelines" element={<Pipelines />} />
        <Route path="cron-jobs" element={<CronJobs />} />
        <Route path="duckdb" element={<DuckDBExplorer />} />
        <Route path="postgres" element={<PostgresExplorer />} />
        <Route path="subscriptions" element={<APISubscriptions />} />
        <Route path="subscription-plans" element={<SubscriptionPlans />} />
        <Route path="system" element={<System />} />
        <Route path="admins" element={<Admins />} />
        <Route path="audit-log" element={<AuditLog />} />
        <Route path="health-check" element={<HealthCheck />} />
        <Route path="profile" element={<Profile />} />
        <Route path="blog" element={<Blog />} />
      </Route>

      {/* Catch all - redirect to dashboard */}
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  )
}

export default App
